<template>
  <div>
    <div :class="`${classPart}-popover-wrapper`">
      <div class="stats-info-table custom-table">
        <div class="stats-info-table-header custom-theader">
          <div class="custom-row">
            <div class="table-cell">
              {{metricLabel}}
            </div>
            <div class="table-cell">
              {{ $t('DASHBOARD.metricPopover.zones')}}
            </div>
          </div>
        </div>

        <div class="custom-tbody">
          <div class="custom-row">
            <div class="table-cell">
              {{ $t('DASHBOARD.metricPopover.low')}}
            </div>
            <div class="table-cell">
              {{zone1Label}}
            </div>
          </div>

          <div class="custom-row">
            <div class="table-cell">
              {{ $t('DASHBOARD.metricPopover.moderate')}}
            </div>
            <div class="table-cell">
              {{zone2Label}}
            </div>
          </div>

          <div class="custom-row">
            <div class="table-cell">
              {{ $t('DASHBOARD.metricPopover.high')}}
            </div>
            <div class="table-cell">
              {{zone3Label}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SESSION_METRICS } from '@/constants/SessionConsts'

export default {
  name: 'MetricPopoverContent',
  props: [
    'metric',
    'metricLabel',
    'zone1Label',
    'zone2Label',
    'zone3Label'
  ],
  data () {
    return {
      sessionMetrics: SESSION_METRICS
    }
  },
  computed: {
    classPart () {
      switch(this.metric) {
        case this.sessionMetrics.TIME_ABOVE_80_PERCENT_HR:
          return 'hr'
        case this.sessionMetrics.AP:
          return 'ap'
        case this.sessionMetrics.DISTANCE:
          return 'distance'
        case this.sessionMetrics.WORKLOAD:
          return 'workload'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .stats-info-table {
    display: table;
    width: 100%;
    min-width: 190px;

    .custom-row {
      border: none;

      .table-cell {
        color: $white;
        padding: 7px 10px;
        height: auto;
        font-size: 12px;
        font-weight: 300;
      }
    }

    .custom-tbody .custom-row {
      border: none;

      .table-cell {
        padding: 7px 10px;
      }
    }

    .stats-info-table-header {
      .table-cell {
        background-color: $flush-mahogany;
        padding: 10px;

        &:first-child {
          border-top-left-radius: 5px;
        }

        &:last-child {
          border-top-right-radius: 5px;
        }
      }
    }
  }

  .ap-popover-wrapper {
    .stats-info-table-header {
      .table-cell {
        background-color: $luxor-gold;
      }
    }
  }

  .distance-popover-wrapper {
    .stats-info-table-header {
      .table-cell {
        background-color: $calipso;
      }
    }
  }

  .workload-popover-wrapper {
    .stats-info-table-header {
      .table-cell {
        background-color: $electric-violet;
      }
    }
  }
</style>
